import { ReactElement } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';
import Link from '@Hotels-at-Home/hah-fe-core/dist/components/Link';

const HeroSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$heroSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$hero' });

  return (
    <section className="base-section hero-section hero-wrap" id="HP_hero_bed">
      <Link href={tLink('wHotelsBed')}>
        <div className="hero-copy-wrap">
          <div className="stack">
            <h1>
              <Trans i18nKey="title" t={t} components={{ span: <span /> }} />
            </h1>
            <p className="sub-copy">{t('description')}</p>
            <Button ariaLabel={t('wHotelsBedAlt')}>{tButton('shopNow')}</Button>
          </div>
        </div>
        <div className="hero-image">
          <picture>
            <source
              srcSet="/images/homePage/heroSection/w-hotels-hero-bed-mob.webp"
              media="(max-width: 660px)"
            />
            <img
              src="/images/homePage/heroSection/w-hotels-hero-bed.webp"
              alt={t('wHotelsBedAlt')}
              width="1920"
              height="800"
              loading="eager"
              fetchPriority="high"
            />
          </picture>
        </div>
      </Link>
    </section>
  );
};

export default HeroSection;
